import { YEAR_MAX, YEAR_MIN } from '~/shared/config/masks'
import { sanitizePhoneNumber } from '~/shared/lib/utils'

type ValidationResult = {
  isValid: boolean
  message?: string
}

/**
 * Validates phone number using the same logic as phonesArraySchema
 * from ~/shared/lib/schemas.ts
 * Checks for Russian phone numbers (+7)
 */
export const phoneValidator = (value: string): ValidationResult => {
  const sanitized = sanitizePhoneNumber(value)

  if (sanitized.length === 0) {
    return {
      isValid: false,
      message: 'Телефон не может быть пустым',
    }
  }

  // Check if starts with 7
  if (!sanitized.startsWith('7')) {
    return {
      isValid: false,
      message: 'Номер должен начинаться с 7',
    }
  }

  // Check length (should be 7 + 10 digits = 11 characters)
  if (sanitized.length !== 11) {
    return {
      isValid: false,
      message: 'Неверный номер телефона',
    }
  }

  return {
    isValid: true,
  }
}

/**
 * Validates year number
 */
export const yearValidator = (value: string): ValidationResult => {
  const year = parseInt(value, 10)

  if (isNaN(year)) {
    return {
      isValid: false,
      message: 'Введите корректный год',
    }
  }

  if (year < YEAR_MIN || year > YEAR_MAX) {
    return {
      isValid: false,
      message: `Год должен быть от ${YEAR_MIN} до ${YEAR_MAX}`,
    }
  }

  return {
    isValid: true,
  }
}

/**
 * Transforms string to number for years
 */
export const yearTransformer = (value: string): number => {
  return parseInt(value, 10)
}

/**
 * Sanitizes phone number before saving
 * Removes + sign from the beginning
 */
export const phoneTransformer = (value: string): string => {
  return sanitizePhoneNumber(value).replace(/^\+/, '')
}
